export default __webpack_public_path__ + "static/media/iferntile.b82c04ac.png";